import { connect } from "@vue/devtools-electron";
import { addCustomCommand, addCustomTab, devtools as devtools$1, onDevToolsClientConnected, onDevToolsConnected, removeCustomCommand } from "@vue/devtools-kit";

//#region src/index.ts
const devtools = {
	...devtools$1,
	connect
};

//#endregion
export { addCustomCommand, addCustomTab, devtools, onDevToolsClientConnected, onDevToolsConnected, removeCustomCommand };